<script>
import { mapGetters } from 'vuex'

function filterDatasets (year, list) {
  const result = {
    all: [],
    surv: []
  }
  if (year !== '2019') {
    result.obs = []
  }

  for (let i = 0; i !== list.length; ++i) {
    const dset = list[i]
    result.all.push(dset)
    if (dset.match(/-/) == null) {
      result.surv.push(dset)
      if (year !== '2020' && result.obs != null) {
        result.obs.push(dset)
      }
    } else if (dset.match(/-SURV-/) != null) {
      result.surv.push(dset)
    } else if (result.obs != null) {
      result.obs.push(dset)
    }
  }
  return result
}

export default {

  computed: {
    ...mapGetters({
      datasetList: 'dataset/getAllDatasetNamesByYear'
    }),

    datasetListLoaded: function () {
      return this.datasetList != null
    },

    availableDatasetsByYear: function () {
      if (!this.datasetListLoaded) {
        return null
      }

      const result = {
        all: {},
        obs: {},
        surv: {}
      }
      for (let i = 0; i !== this.datasetList.length; ++i) {
        const ds = this.datasetList[i]
        const lists = filterDatasets(ds.year, ds.list)
        result.all[ds.year] = lists.all
        if (lists.obs != null) {
          result.obs[ds.year] = lists.obs
        }
        result.surv[ds.year] = lists.surv
      }

      return result
    }
  },

  methods: {
    fillDatasetNames: function (region) {
      if (!this.datasetListLoaded) {
        this.$store.dispatch('dataset/allSpiadiNames', region)
      }
    }
  }
}
</script>
